import React from 'react';
import { Button } from 'antd';
import { I18n } from '@aws-amplify/core';

interface OptionDropdownProps {
	children: string;
	loading: boolean;
	disabled?: boolean;
	onClick: React.MouseEventHandler<HTMLElement>;
}

export const OptionDropdown: React.FC<OptionDropdownProps> = ({
	onClick,
	loading,
	children,
	disabled = false
}): JSX.Element => (
	<Button type="link" loading={loading} disabled={disabled} onClick={onClick}>
		<span>{I18n.get(children)}</span>
	</Button>
);
